<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__scopecity">
      <div class="leftNav" v-if='false' >
       <!-- <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>  -->
        <el-tree
     
         :data="getPageList"
         :props="defaultProps"
          @node-click="handleNodeClick"
          class="filter-tree"
          :filter-node-method="filterNode"
          ref="tree"
          ></el-tree>
      </div>
      <div class="rightTable">

      
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.pageId" filterable clearable placeholder="请选择落地页">
            <el-option
                    v-for="item in pages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.city" filterable clearable placeholder="请选择城市">
            <el-option
                    v-for="item in citys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.strategy" filterable clearable placeholder="请选择投放策略">
            <el-option
                    v-for="item in strategys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.date"
                  type="date"
                  placeholder="选择统计日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:scopecity:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
   
      </el-form>
      
      <el-table  v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
        <!-- <el-table-column  type="expand" width="100px" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tree :data="getArr(scope.row)" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
          </template>
        </el-table-column> -->
        <el-table-column prop="id" label="id" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="childHandle(scope.row)" show-overflow-tooltip>{{ scope.row.id }}</el-button>
          </template>
        </el-table-column>
        <el-table-column  width="200px" prop="pageName" label="落地页" header-align="center" align="center" show-overflow-tooltip>
          
        </el-table-column>
        <el-table-column prop="standard" label="落地页标识" header-align="center" align="center">
          <template slot-scope="scope">
               <el-tag v-if="scope.row.standard == 1"  size="small">标准</el-tag>
               <el-tag v-else type="warning" size="small">非标准</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="城市" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="strategy" label="投放策略" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.strategy === 1" size="small">轮询</el-tag>
            <el-tag v-if="scope.row.strategy === 2" size="small">随机</el-tag>
          </template>
        </el-table-column>
<!--        <el-table-column prop="status" label="状态（开1、关0）" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150" >
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:scopecity:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:scopecity:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './scopecity-add-or-update'
import { addDynamicRoute } from '@/router'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/scopecity/page',
        getDataListIsPage: true,
        exportURL: '/sys/scopecity/export',
        deleteURL: '/sys/scopecity',
        deleteIsBatch: true
      },
      filterText:'',
      citys:[],
      pages:[],
      pageList: [{
          label: '落地页1',
          children: [
            {
             label: '上海',
           },
           {
             label: '北京',
           },
         ]
        }],

        defaultProps: {
          children: 'children',
          label: 'label',
          
        },

      strategys:[
        // {
        //   'label':'顺序',
        //   'value':1,
        // },
        {
          'label':'轮询',
          'value':1,
        },
        {
          'label':'随机',
          'value':2,
        }
      ],
      dataForm: {
        pageId: '',
        city: '',
        strategy:''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.query()
      this.getCityOptions();
      this.getPageOptions();
    }
  },
  computed:{
    getPageList(){
      return this.dataList.map(item => {
        return {
          label: item.pageName,
          ...item,
          children: [
          ...item.city.split(',').map(item1 => ({ label: item1, city: item.city, pageName: item.pageName, id: item.id})),
         ]
        }
      })
    }
  },
  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
  methods: {
    filterNode(value, data) {
      console.log(value,data)
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
    
    // 回调函数 返回树形数据
    getArr(event){
      return [{
          label: event.pageName,
          children: [
            ...event.city.split(',').map(item => ({ label: item }))
         ]
        }]
    },
    handleNodeClick(data) {
        console.log(data);
        this.childHandle(data)
      },
    //初始化下拉框中的选项
    async getCityOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.citys.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    //初始化落地页下拉框中的选项
    async getPageOptions() {
      this.$http.get(`/sys/landingpages/list`).then(({ data: res }) => {
       
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pages=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.pages.push({label:element.name,value:element.id})
          })
        }
      }).catch(() => {})
    },
    // 子级
    childHandle (row) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__${row.id}`,
        title: `${this.$route.meta.title} - ${row.pageName} - ${row.city}`,
        path: 'sys/scopecitycompany',
        params: {
          scopeCityId: row.id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    }
  }
}
</script>
<style scoped lang="scss">
.mod-demo__scopecity{
  display: flex;
  .leftNav{
    margin-right: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* 添加阴影效果 */
    border-radius: 10px; /* 添加圆角 */
    padding: 20px; /* 添加内边距 */
  }
  .rightTable{
    flex: 1;
  }
}

</style>
